import {Component} from 'react';
import "./ContactUs/contactUs.css";
import "../../css/styles.css";
import ContactUsModal from './contact_us_modal';
import {setHeadersForFetch} from '../../objects/CommonUse/set_headers_for_fetch'
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
//import ConfigFile from '../../datasets/config_file';
import Config from '../../config';
import {buildUrl} from '../../objects/CommonUse/build_URL';
import InformationModal from '../shared-components/information_modal';
//import SendEmail from '../../objects/CommonUse/send_email-save;'

class ContactUsMain extends Component {
    constructor(props) {
        super(props);
        this.state={
          openModal: false,
          openInformationModal: false,
          headers: {},
          subProcess: "ContactUs",
          environment: Config.dataURL.currentEnv,
                                   
        };   
        this.typeOfModal = "";
    }

    setTypeOfModal(modalName){
        this.typeOfModal = modalName;
        this.setState({openModal: true});
    }

    closeModals() {
        this.typeOfModal = "";
        this.setState({openModal: false, openInformationModal: false});
    }
        
    submitContactUsForm(contactUsObj) {
    //    let message = "Subject: " + contactUsObj.subject + " - " + contactUsObj.messageText;
    //    need to combine subject and messageText if using emailjs...    
        let fromName = contactUsObj.firstName;
        let userName = sessionStorage.getItem("username");
        if (userName === null){
            userName = "NotSignedIn"
        }
        let toName = "MoneyTrain Game"
        this.emailParms={from_name: fromName, userName: userName, to_name: toName, subject: contactUsObj.subject,
            message: contactUsObj.messageText, reply_to: contactUsObj.emailAddress};
    //    let templateName=ConfigFile.login.contactTemplate;
    //    let serviceID = ConfigFile.login.contactServiceID;
    //    let publicID = ConfigFile.login.contactPublicID;
        //console.log("sending email --  template: ", templateName, "  serviceID: ", serviceID,
        //    " publicID: ", publicID);
        this.emailParms={...this.emailParms, emailType: contactUsObj.emailType};
        // SendEmail(this.emailParms, templateName, serviceID, publicID);
        this.saveContactUs();   
        this.informationCode = "EmailSent";
        this.setState({openInformationModal: true, openModal: false});
    }

    closeInformationModal(){
        this.typeOfModal = "";
        this.setState({openInformationModal: false});
    }
   
    
    render() {
        this.username = sessionStorage.getItem("username");
                                             
    return <>
        <div className="col-sm-8">
            <div className="card mt-3 rounded-corners-lg height-max container"> 
                <button className="pages-back-button ml-4 mt-4" 
                        onClick ={()=> this.props.goBack()}>
                                Back
                </button>
                <h3 className="p-0 text-center">Contact Us</h3>
                <h5 className="mt-0 text-center">Send an Email</h5>
               
                <div className="overflow-scroll container mt-2">
                    <h6 className="font-weight-bold text-center">We would love to hear from you!!</h6>
                    
                    <div className="contact-us-small-text ml-4 mr-4 mt-4">
                        Just click on the <b>"Send Email"</b> button if you have a 
                        a general comment or a question about the game.  This game is still in early
                        stages of development, so your comments will help us identify things that
                        should change to improve the game or this site.  Also, if you have questions, 
                        we would be happy to provide answers.
                    </div>
                    
                    <span className="row">
                        <div className="col-1 col-md-3 mt-4 ml-3 ml-md-5">
                        <img  className="basic-img-size" src={'./assets/ContactUs/email.jpg'} 
                            alt="writingPic"/>

                        </div>
                        <div className="col-9 col-md-7 mt-4">
                            {this.typeOfModal !== "SendEmail" ?
                                <div className="text-center mt-3 ml-3">
                                    <button className="good-looking-button" 
                                        onClick ={()=> this.setTypeOfModal("SendEmail")}>
                                            Send Email
                                    </button>
                                </div>
                        
                            :
                                <ContactUsModal openModal={this.state.openModal} 
                                    onClose={() => this.closeModals()} 
                                    onSubmit={(contactUsObj) => this.submitContactUsForm(contactUsObj)}
                                    />
                            }
                                           
                        </div>
                         {this.state.openInformationModal   ?
                            <InformationModal   
                                time={6000}
                                show={this.state.openInformationModal}
                                infoCode={this.informationCode}
                                onClose={() => this.closeInformationModal()}
                            />
                        :
                            null
                        }
                    </span>
                </div>
            </div>  
        </div>
    </>
    }
 
    saveContactUs() {
        let headers = {'Content-Type': 'application/json',
            'Authorization': {},
        };
        if (this.emailParms.userName !== "NotSignedIn"){
            headers = setHeadersForFetch();
        }
        if (!this.emailParms.formData){
            this.emailParms.formData = {};
        }
        let dateObj = getCurrentDateTime();
        let bodyObj = {
            fromName: this.emailParms.from_name,
            toName: this.emailParms.to_name,
            userName: this.emailParms.userName,
            subject: this.emailParms.subject,
            message: this.emailParms.message,
            formData: this.emailParms.formData,
            replyTo: this.emailParms.reply_to,
            emailType: this.emailParms.emailType,
            dateAdded: dateObj.date,
            timeAdded: dateObj.time
        };
        const funcName = "saveContactUsEmail";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
      
        fetch(uri,
            {
            method:'post',
            headers: headers,
            body: JSON.stringify(bodyObj)
            })
            .then(response => {
                    if (response.ok){
                        response.json().then(data => {
                            const output = JSON.parse(data);
                            const statusCode = output.statusCode;
                            if (statusCode === 200){
                                //  the call to save the email was successful!
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                                this.props.processError(errorObj);
                            }
                    });
                };
        });
             
    }
 
}

export default ContactUsMain;